import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';
import { DeleteFromWishlistDto } from '../../../dto/wishlist/deletefromwishlist/deletefromwishlistdto';

export interface DeleteFromWishlistResponse extends APIResponse
{
    getDeleteFromWishlistDto(): DeleteFromWishlistDto;
}

export class DeleteFromWishlistResponseDtoImpl extends APIResponseDtoImpl implements DeleteFromWishlistResponse
{
    private deleteFromWishlistDto : DeleteFromWishlistDto;

    getDeleteFromWishlistDto(): DeleteFromWishlistDto
    {
        return this.deleteFromWishlistDto;
    }
    setDeleteFromWishlistDto(deleteFromWishlistDto: DeleteFromWishlistDto)
    {
        this.deleteFromWishlistDto = deleteFromWishlistDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/wishlist/deletefromwishlist/deletefromwishlistresponse.tsx